module.exports = "<div class=\"jumbotron\">\n    <h1>About Audience Store</h1>\n    <p>This is the administration app for our SSO audiences</p>\n    <p>More blah about SSO and OAuth...</p>\n    <p>for more info see <a target=\"_blank\" href=\"https://jwt.io/\">Json Web Tokens</a> and <a target=\"_blank\" href=\"https://oauth.net/2/\">OAuth</a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.html
// module id = ./src/app/about/about.component.html
// module chunks = main